import * as React from "react";
import Layout from "../components/layout";
import Networks from "../components/OurNetworks/Networks";
import Seo from "../components/seo";

const StakeholdersAndPartners = () => (
  <Layout>
    <Seo
      title="Stakeholders and Partners"
      description="The companies that make up and work alongside the S.T.A.R. Services Group - terminal, port services, construction, IT, and fuel logistics partners in the Philippines."
      pathname="/stakeholders-and-partners/"
    />
    <Networks />
  </Layout>
);

export default StakeholdersAndPartners;
